export function getBarRadius(barSize: number = 0): number {
  if (barSize >= 13) {
    return 4;
  } else if (barSize >= 10) {
    return 3;
  }

  return 2;
}
